<!-- <div class="no-access-wrapper">
    <div class="no-access-card">
      <ion-icon name="shield-off-outline" class="icon"></ion-icon>
      <h1>Access Denied</h1>
      <p class="message">
        You do not have the required permissions to access this page.
      </p>
      <ion-button routerLink="/login" color="primary" class="btn">
        <ion-icon name="log-in-outline" slot="start"></ion-icon>
        Return to Login
      </ion-button>
    </div>
  </div> -->

  <div class="access-denied-page">
    <div class="glass-card">
      <div class="icon-wrapper">
        <span class="error-icon">🚫</span>
      </div>
      <h1>Access Denied</h1>
      <p>
        You do not have the required permissions to access this Application.
      </p>
      <button (click)="goToLogin()">🔁 Go to Login</button>
    </div>
  </div>
  